module.exports = __webpack_public_path__ + "img/banner06.efad3ff3.png";